import loadable from '@loadable/component';
import {loadableAuthParams} from '@components/Skeleton/loadableParams';

const Survey = {
  SurveyStudent: loadable(() => import('./Survey'), loadableAuthParams),
};

export default Survey;
